export enum CmdiColumnVariantType {
  I18N = 'i18n',
  STRING = 'string',
  NUMBER = 'number',
}
export type CmdiColumnVariant = `${CmdiColumnVariantType}`;
